import { type ComponentPropsWithoutRef, type ElementType, type ReactNode } from "react";
import { styled, type SxProps, type Theme } from "~/common/mui";

const StyledTitle = styled("h1", {
  shouldForwardProp: (prop) => prop !== "sx",
})(({ theme }) => ({
  ...theme.typography.headlineSmall,
  margin: 0,
  [theme.breakpoints.up("desktop-s")]: {
    ...theme.typography.headlineMedium,
  },
}));

const HelpLink = styled("span")(({ theme }) => ({
  ...theme.typography.bodyMedium,
}));

const TitleSpacer = styled("hr")(({ theme }) => ({
  border: "none",
  borderTop: `1px solid ${theme.palette.divider}`,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up("desktop-s")]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
}));

export interface PageTitleProps {
  className?: string;
  sx?: SxProps<Theme>;
  title: ReactNode;
  tag?: keyof JSX.IntrinsicElements;
  linkHelp?: ReactNode;
}

/**
 * @deprecated
 * Please use PageElements.Title instead
 */
const PageTitle = (props: PageTitleProps) => {
  const { className, sx, title, tag = "h1", linkHelp } = props;

  const Tag = tag as ElementType;

  return (
    <>
      <StyledTitle as={Tag} className={className} sx={sx}>
        {title}
      </StyledTitle>
      {linkHelp && <HelpLink>{linkHelp}</HelpLink>}
      <TitleSpacer />
    </>
  );
};

export default PageTitle;
